import styled from 'styled-components/macro';
import { shadows } from '../../styles/vars';

const Paper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 2px;
  background-color: #3d3234;
  box-shadow: ${shadows.paper};
`;

export default Paper;
